import {AdvancedFilter} from "@/poster-gallery/classes/advanced-filters/advanced-filter";
export class OrientationFilter extends AdvancedFilter {
    static advancedFiltersArrayKey = 'orientation';
}